import { createApi } from '@core/fetch'

export default {
  // 获取水镜案例详情（数据结构和婚礼纪平台相同）
  getShuijingCaseWithPlatformlike: createApi(
    '/p/wedding/index.php/Admin/APIGeneralModule/GeneralAlbumDetail'
  ),
  // 获取水镜案例列表
  getShuijingCaseListAll: createApi(
    //eslint-disable-next-line
    '/hms/hljStore/api/generalAlbum/getAlbumList'
  ),
  // 获取水镜分类级联列表
  getMirrorCategoryCascaderListNew: createApi(
    //eslint-disable-next-line
    '/hms/hljStore/api/generalModule/getAllStructure'
  ),
  // 将婚礼纪平台案例导入到水镜门店
  importPlatformCaseToShuijing: createApi.post(
    '/p/wedding/index.php/admin/APIGeneralModule/ImportToWaterMirror'
  ),

  /**-----------------分割线----------*/
  // 上面的都是新的，下面的以后看情况删除
  // 获取水镜分类列表
  getMirrorCategoryCascaderList: createApi(
    // '/p/wedding/index.php/Admin/APISetMealMirrorCategory/AllMirrorCategory'
    '/p/wedding/index.php/Admin/APISetMealMirrorCategory/list?page=1&per_page=1000&sort=weight'
  ),
  // 获取水镜分类级联列表
  getMirrorCategoryList: createApi(
    '/p/wedding/index.php/Admin/APISetMealMirrorCategory/list'
  ),
  // 获取案例列表，门店案例传is_shop=1，客照案例is_kezhao=1，平台案例不传
  getCaseList: createApi('/p/wedding/index.php/Admin/APISetMeal'),
  // 获取平台案例分类列表
  getPlatformCategoryList: createApi(
    '/p/wedding/Admin/APISetMealMerchantCategory/All'
  ),
  // 获取平台案例列表: 门店案例传is_shop=1，客照案例is_kezhao=1，平台案例不传
  getPlatformCaseList: createApi('/p/wedding/index.php/Admin/APISetMeal'),
  importPlaceFromPlatform: createApi.post(
    '/p/wedding/index.php/admin/APIHotelWaterMirror/weddingHallToMirrorHall'
  ),
  // 获取场地列表
  getHallList: createApi(
    '/p/wedding/index.php/admin/APIHotelWaterMirror/hallList'
  ),
  // 获取场地详情
  getHallDetail: createApi(
    '/p/wedding/index.php/admin/APIHotelWaterMirror/hallDetail'
  ),
  // 删除场地
  deleteHall: createApi.post(
    '/p/wedding/index.php/admin/APIHotelWaterMirror/delHall'
  ),
  // 移除场地
  removeHall: createApi.post(
    '/p/wedding/index.php/admin/APIHotelWaterMirror/removeHall'
  ),
  // 新增、编辑场地
  editHall: createApi.post(
    '/p/wedding/index.php/admin/APIHotelWaterMirror/hall',
    {
      ignore: [undefined, null]
    }
  )
}
